import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { createFileRoute, Link } from "@tanstack/react-router";
import Logo from "@/assets/wiseline-color.png";
import Page from "@/components/Page";

function NotFoundPage() {
  return (
    <Page contentPadding maxWidth="xl">
      <Stack
        component={Paper}
        variant="outlined"
        sx={{
          gap: 1,
          p: 2,
          mt: 5,
          maxWidth: 450,
          mx: "auto",
        }}
      >
        <Box alt="Wiseline logo" component="img" src={Logo} sx={{ height: 75, m: "auto", px: 4 }} />
        <Typography align="center" sx={{ my: 2 }} variant="h1">
          Ops...
        </Typography>
        <Typography align="center" gutterBottom variant="h3">
          Vi finner ikke siden du leter etter
        </Typography>
        <Button color="primary" component={Link} fullWidth to="/" variant="contained">
          Gå til forsiden
        </Button>
      </Stack>
    </Page>
  );
}

export const Route = createFileRoute("/$")({
  component: NotFoundPage,
});
